import { useLocation } from 'react-router-dom';
import { ROUTE_TITLES } from '../constants';

export const usePageTitle = () => {
    const location = useLocation();
    document.title = ROUTE_TITLES[location.pathname] || 'Giftly';
};
